<!-- eslint-disable vue/require-explicit-emits -->
<template>
  <iColumn
    :width="fullTextOptionsAttributes.width"
    :min-width="fullTextOptionsAttributes.minWith"
    :max-width="fullTextOptionsAttributes.maxWith"
    height="hug"
  >
    <iText
      v-bind="fullTextOptionsAttributes"
      :border-top="myBorderSides.top"
      :border-bottom="myBorderSides.bottom"
      :border-left="myBorderSides.left"
      :border-right="myBorderSides.right"
      :style-overrides="fullTextOptionsAttributes.textStyleOverrides"
      :style="[!renderedText && editMode ? {opacity: 0.5} : null, clickableStyle]"
      :class="{'clickable-text': hasClickValue}"
      @click="handleClickAction"
    >
      {{ renderedText || (editMode ? placeholderText : "") }}
    </iText>
  </iColumn>
</template>

<script>
// Lightweight canvas render for unselected `TextElement` instances.
// Mirrors `TextElement.vue`'s iText branch but skips: iRichText, the
// link-picker modal teleport, the inspector inline-edit click handler,
// every editor-only watcher, and the heavy mixin chain (no
// StaticBrandedTextElementMixin → no TextElementMixin's 27 computeds /
// 18 methods / 2 watchers).
//
// Mounted by `DynamicComponentBuilderElement` whenever the element is
// not selected for editing OR is rendered on a non-default breakpoint
// frame. Selection re-routes mounting back to `TextElement.vue` so the
// active element gets the full editor treatment.
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import {
  TextElementRenderMixin,
} from "%/dynamic-component-editor/standard-elements/text-element/text-element-render-mixin";

export default {
  name: "TextElementProduction",
  // Production twin: exempt from the palette's elementPanelSettings gate.
  production: true,
  mixins: [DynamicElementMixin, TextElementRenderMixin],
};
</script>

<style lang="scss" scoped>
.clickable-text {
  cursor: pointer !important;
}
</style>
